import { Outlet } from 'react-router-dom'
import { Container, Row, Col, Nav } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

function AdminLayout(): JSX.Element {
  const location = useLocation()
  
  return (
    <Container fluid className="mt-4">
      <Row>
        <Col md={3} lg={2} className="d-none d-md-block bg-light sidebar">
          <div className="position-sticky">
            <Nav className="flex-column">
              <h5 className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                <span>Admin Panel</span>
              </h5>
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/admin"
                  active={location.pathname === '/admin'}
                >
                  Dashboard
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/admin/users"
                  active={location.pathname === '/admin/users'}
                >
                  User Management
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/admin/settings"
                  active={location.pathname === '/admin/settings'}
                >
                  System Settings
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/admin/prompts"
                  active={location.pathname === '/admin/prompts'}
                >
                  Prompts
                </Nav.Link>
              </Nav.Item>
              {/* TODO: Implement Sandbox functionality */}
              {/* 
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/admin/sandbox"
                  active={location.pathname === '/admin/sandbox'}
                >
                  Sandbox
                </Nav.Link>
              </Nav.Item>
              */}
            </Nav>
          </div>
        </Col>
        <Col md={9} lg={10} className="ms-sm-auto px-md-4">
          <Outlet />
        </Col>
      </Row>
    </Container>
  )
}

export default AdminLayout
